export async function copyText(value) {
  const text =
    String(value == null ? '' : value);

  if (!text.trim()) {
    throw new Error(
      'There is no text available to copy.'
    );
  }

  if (
    window.isSecureContext &&
    navigator.clipboard &&
    typeof navigator.clipboard.writeText ===
      'function'
  ) {
    try {
      await navigator.clipboard.writeText(
        text
      );

      return true;
    } catch (_) {
      // Use the browser-compatible fallback.
    }
  }

  const textArea =
    document.createElement('textarea');

  textArea.value = text;
  textArea.setAttribute(
    'readonly',
    ''
  );

  textArea.style.position = 'fixed';
  textArea.style.top = '-9999px';
  textArea.style.left = '-9999px';
  textArea.style.opacity = '0';

  const activeElement =
    document.activeElement;

  const selection =
    document.getSelection();

  const savedRanges = [];

  if (selection) {
    for (
      let index = 0;
      index < selection.rangeCount;
      index += 1
    ) {
      savedRanges.push(
        selection.getRangeAt(index)
      );
    }
  }

  document.body.appendChild(textArea);

  textArea.focus();
  textArea.select();
  textArea.setSelectionRange(
    0,
    text.length
  );

  let copied = false;

  try {
    copied =
      document.execCommand('copy');
  } finally {
    document.body.removeChild(
      textArea
    );

    if (
      activeElement &&
      typeof activeElement.focus ===
        'function'
    ) {
      activeElement.focus();
    }

    if (selection) {
      selection.removeAllRanges();

      savedRanges.forEach(range => {
        selection.addRange(range);
      });
    }
  }

  if (!copied) {
    throw new Error(
      'The browser refused clipboard access.'
    );
  }

  return true;
}
